export default "__VITE_ASSET__CaZ4pXAH__"